export { CustomMapStyles as default } from "./CustomMapStyles";
